export default __webpack_public_path__ + "static/media/Shot_5.0000.ef24a624.png";